<template>
    <b-card body-class="p-2">
        <b-row class="d-flex title-bar-block mb-0">
            <b-col cols="1">
                <b-button size="sm" @click.stop="visible = !visible" variant="outline-light">
                    <b-icon :icon="`arrow-${visible ? 'up' : 'down'}`"></b-icon>
                </b-button>
            </b-col>
            <b-col cols="6" style="text-align: left;">
                <span class="me-2">{{ `${dataLabel}-rules` }}</span>
            </b-col>
            <b-col>
                <slot name="header"></slot>
            </b-col>
        </b-row>
        <b-card-body class="p-0">
            <b-collapse v-model="visible" class="mt-2">
                <slot></slot>
            </b-collapse>
        </b-card-body>
    </b-card>
</template>

<script lang="js">
export default {
    name: 'slotContainer',


    props: {
        dataLabel: { type: String, required: true },
    },

    data() {
        return {
            visible: false
        }
    },


    computed: {

    },
    watch: {

    },



    methods: {

    },
}
</script>